export function formatIST(timestamp) {
  return new Date(timestamp).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function timeAgo(timestamp) {
  const seconds = Math.floor((Date.now() - timestamp) / 1000);
  const intervals = [
    { label: 'y', seconds: 31536000 },
    { label: 'mo', seconds: 2592000 },
    { label: 'd', seconds: 86400 },
    { label: 'h', seconds: 3600 },
    { label: 'm', seconds: 60 },
  ];
  for (const { label, seconds: s } of intervals) {
    const count = Math.floor(seconds / s);
    if (count >= 1) return `${count}${label} ago`;
  }
  return 'just now';
}

export function copyToClipboard(text) {
  return navigator.clipboard.writeText(text);
}

export async function hashString(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, '0')).join('');
}

export function getFileType(filename) {
  const ext = filename.split('.').pop()?.toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (['txt', 'text'].includes(ext)) return 'text';
  if (ext === 'md') return 'md';
  return 'doc';
}

export function wordCount(text) {
  return text.split(/\s+/).filter(w => w.length > 0).length;
}

export function truncate(str, max = 50) {
  if (str.length <= max) return str;
  return str.substring(0, max) + '...';
}

export function uid() {
  return `${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
}

export const ACCEPTED_FILE_TYPES = {
  'application/pdf': 'pdf',
  'text/plain': 'text',
  'text/markdown': 'md',
};
export const ACCEPTED_EXTENSIONS = '.pdf,.txt,.md';
